import { Footer } from '@cox/core-ui8/dist/Footer'

import withAEM from '../../hoc/withAEM'

export default withAEM(Footer, { compName: 'Footer', atomSpacing: true })
